import React from 'react';
import classNames from 'classnames';

export default function TransportationIcon({ className = '' }) {
	return <span className={classNames('icon icon-transportation', className)} />;
}
